import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';

import './WalletDepositModalForm.sass'

import {Field, reduxForm, SubmissionError} from 'redux-form';
import {FormattedMessage} from 'react-intl';

import FieldText from '../../components/fields/fieldText/FieldText';
import FormSection from '../../components/fields/formSection/FormSection';
import CheckoutMethodField from '../../components/checkout/CheckoutMethodField';
import Notification from '../../components/notification/Notification';
import Button from '../../components/button/Button';
import Pricing from '../../components/pricing/Pricing';
import Tooltip from '../../components/tooltip/Tooltip';
import ChannelPrice from '../../containers/channelUtils/ChannelPrice';

@injectIntl
@reduxForm({
  form: 'walletCheckout'
})
export default class WalletDepositModalForm extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {checkoutMethod: {}};
    this.debounceTimer = null;
  }

  static propTypes = {
    checkoutMethods: PropTypes.array.isRequired,
  };

  componentDidMount() {
    const {checkoutMethods, change} = this.props;

    change('checkoutMethod', checkoutMethods[0].code);

    this.setState({checkoutMethod: checkoutMethods[0].code})
  }
  componentWillUnmount() {
    clearTimeout(this.debounceTimer);
  }

  applyHandler = ({quantity, checkoutMethod}) => {
    const {onApply} = this.props;

    quantity = parseFloat(quantity);

    if (Number.isNaN(quantity) || quantity <= 0) {
      throw new SubmissionError({quantity: <FormattedMessage id="section.wallet.quantity.error"/>});
    }

    return onApply({quantity, checkoutMethod});
  };

  removeHandler = () => {
    const {onRemove, change} = this.props;

    change('quantity', null)

    return onRemove();
  };

  submitHandler = ({quantity, checkoutMethod}) => {
    const {isApplied, onSubmit} = this.props;

    if (!isApplied) {
      return;
    }

    quantity = parseFloat(quantity);

    if (Number.isNaN(quantity) || quantity <= 0) {
      throw new SubmissionError({quantity: <FormattedMessage id="section.wallet.quantity.error"/>});
    }

    return onSubmit({quantity, checkoutMethod});
  };

  debouncedSubmit = () => {
    const {handleSubmit, submitting} = this.props;

    if (submitting) {
      return;
    }

    clearTimeout(this.debounceTimer);

    this.debounceTimer = setTimeout(() => {
      handleSubmit(this.applyHandler)();
    }, 1000);
  };

  handleBlur = () => {
    const {handleSubmit, submitting} = this.props;

    if (submitting) {
      return;
    }

    clearTimeout(this.debounceTimer);
    handleSubmit(this.applyHandler)();
  };

  render() {
    const {intl, walletCart, checkoutMethods, isApplied, handleSubmit, submitting, error, change} = this.props;

    const {walletPaymentAmount, itemsTotal} = walletCart;

    const _total = walletPaymentAmount
      ? walletPaymentAmount >= itemsTotal
        ? 0
        : itemsTotal + (this.state.checkoutMethod.charge || 0) - walletPaymentAmount
      : itemsTotal + (this.state.checkoutMethod.charge || 0);
    const _subtotal = walletPaymentAmount
      ? walletPaymentAmount >= itemsTotal
        ? itemsTotal
        : itemsTotal +
          (this.state.checkoutMethod.originalCharge || this.state.checkoutMethod.charge || 0)
      : undefined;

    return (
      <div>
        <form className='deposit__quantity-form' onSubmit={handleSubmit(this.applyHandler)}>
          {isApplied ? (
            <Notification onClose={() => this.removeHandler()}>
              <FormattedMessage
                id="section.wallet.added"
                values={{amount: <ChannelPrice component="b" price={itemsTotal}/>}}
              />
            </Notification>
          ) : (
            <FormSection title={<FormattedMessage id="section.wallet.quantity.label"/>}>
              <div className='deposit__quantity'>
                <Field
                  name="quantity"
                  type="number"
                  step="any"
                  className='deposit__quantity-field'
                  placeholder={intl.formatMessage({id: 'section.wallet.placeholder'})}
                  component={FieldText}
                  disabled={submitting}
                  onChange={this.debouncedSubmit}
                  onBlur={this.handleBlur}
                />

                <Button fill loading={submitting} disabled={submitting}>
                  <FormattedMessage id="section.wallet.apply"/>
                </Button>
              </div>
            </FormSection>
          )}
        </form>

        <form onSubmit={handleSubmit(this.submitHandler)}>
          <FormSection title={<FormattedMessage id="section.wallet.payment-method.label"/>}>
            <Field
              name="checkoutMethod"
              methods={checkoutMethods}
              component={CheckoutMethodField}
              onMethodChange={(method) => {
                change('checkoutMethod', method.code);
                this.setState({checkoutMethod: method})
              }}
            />
          </FormSection>

          {isApplied && (
            <div className="deposit__total">
              <Pricing
                accented
                between
                small
                annotation={`${intl.formatMessage({ id: 'page.checkout.total' })}:`}
                value={_total}
                originalValue={_subtotal}
              />

              {this.state.checkoutMethod.charge && _total > 0 && (
                <div>
                  <FormattedMessage
                    id='page.checkout.charge'
                    values={{ amount: <ChannelPrice component='b' price={this.state.checkoutMethod.charge} /> }}
                  />
                </div>
              )}

              {Boolean(walletCart && walletCart.cashback && walletCart.cashback.amount) && (
                <div className='deposit__total-cashback'>
                  <FormattedMessage
                    id='page.checkout.cashback.total'
                    values={{ amount: <ChannelPrice component='b' price={walletCart.cashback.amount} /> }}
                  />

                  <Tooltip
                    content={<FormattedMessage id="page.checkout.cashback.tooltip.short" />}
                    open={this.state.openTooltip}
                  >
                    <div className='tooltip_trigger' onMouseLeave={() => this.setState({openTooltip: false})} onMouseEnter={() => this.setState({openTooltip: true})} />
                  </Tooltip>
                </div>
              )}
            </div>
          )}

          {error && <p className="error-message">{error}</p>}

          <div className="deposit__add">
            <Button filled loading={submitting && isApplied} disabled={submitting || !isApplied}>
              <FormattedMessage id="section.wallet.action"/>
            </Button>
          </div>
        </form>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/walletDepositModalContainer/WalletDepositModalForm.js